
<template>
    <div>
        <b-modal size="xl" :no-close-on-backdrop="true" id="modal-create" :body-class="['pd-0', {'run-loading': loading }]" title="Documents" hide-footer :centered="true" scrollable v-model="open">
            <div>
                <gofix-table :settings="tableConfig"
                    :table-items="tableItems"
                    @load-items="getTableData"
                    ref="gofixTable">
                    <template slot="gofix_table:download_report" slot-scope="row">
                        <div class="download-file cursor-pointer" @click.stop="downloadFile(row.item, true)">
                            <svg width="13" height="13" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6.78216 9.13875L8.80055 11.2538V1.5C8.80055 0.88125 9.28367 0.375 9.87416 0.375C10.4646 0.375 10.9478 0.88125 10.9478 1.5V11.2538L12.9769 9.13875C13.3956 8.7 14.072 8.7 14.4907 9.13875C14.6917 9.34894 14.8047 9.63429 14.8047 9.93188C14.8047 10.2295 14.6917 10.5148 14.4907 10.725L10.6364 14.7638C10.2177 15.2025 9.54134 15.2025 9.12263 14.7638L5.26837 10.725C4.84967 10.2863 4.84967 9.5775 5.26837 9.13875C5.68708 8.7 6.36345 8.7 6.78216 9.13875ZM17.4004 17.25V11.625C17.4004 11.0062 17.8835 10.5 18.474 10.5C19.0645 10.5 19.5476 11.0062 19.5476 11.625V18.375C19.5476 19.6125 18.5814 20.625 17.4004 20.625H2.36987C1.1889 20.625 0.222656 19.6125 0.222656 18.375V11.625C0.222656 11.0062 0.70578 10.5 1.29626 10.5C1.88675 10.5 2.36987 11.0062 2.36987 11.625V17.25C2.36987 17.8687 2.853 18.375 3.44348 18.375H16.3268C16.9173 18.375 17.4004 17.8687 17.4004 17.25Z" fill="#0f7dfe" />
                            </svg>
                            <span>{{ row.item.path_info_extension }}</span>
                        </div>
                    </template>
                </gofix-table>
            </div>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="downloadingModal.title" hide-footer :centered="true" v-model="downloadingModal.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">Loading</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
    </div>
</template>
<script>

import { mapGetters } from 'vuex';
export default {
    name: 'modal-avenue-of-feedback',
    components: {},
    props: {
        value: {
            type: Boolean,
            default: false
        },
        inspection_id: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            open: false,
            tableItems: [],
            tableConfig:{
                name: 'garuda-inspection-documents',
                controls:{
                    create: false,
                    delete: false,
                    tableImport: false,
                    tableExport: false,
                    tableColumnSettings: false,
                    tablePagination: false,
                    tableFilter: false,
                    reload: false
                },
                filter: {},
                total: 0,
                fields: [
                    // {
                    //     key: 'actions',
                    //     label: '',
                    //     width: 50,
                    //     thStyle: "width:50px",
                    // },
                    {
                        key: 'document_id',
                        label: 'Document ID',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:150px",
                        sorting: false,
                        with:150,
                    },
                    {
                        key: 'name',
                        label: 'Name',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:150px",
                        sorting: false,
                        with:150,
                    },
                    {
                        key: 'download_report',
                        label: 'Download',
                        isActive: 1,
                        isFilter: false,
                        thStyle: "width:150px",
                        sorting: false,
                        with:150,
                        thClass: 'text-center',
                        tdClass: 'text-center'
                    }
                ],
            },
            loading: false,
            retry: 0,
            downloadingModal : {
                open: false,
                title: 'Downloading',
              },
        }
    },
    computed: {
        ...mapGetters({
            garudaToken: 'GarudaController/garudaToken'
        })
    },
    watch: {
        value: function (val) {
            // this.retry = 0
            this.open = val;
        },
        open: function (val) {
            this.$emit('input', val);
        }
    },
    methods: {
        async getTableData(callback){
            if(!this.open) return
            const { tableRequest , resolve,reject } = await callback();
            await this.$store.dispatch("GarudaController/getDocuments", {
                inspection_id: this.inspection_id
            })
                .then(response => {                        
                    this.tableItems = response.items;
                    this.tableConfig.total = response.items.length;
                    // this.retry = 0;
                    resolve(response);
                })
                .catch(async err => {
                    // if(err && err.status && err.status == 401) {
                    //     this.retry = this.retry + 1
                    //     if(this.retry <= 3) {
                    //         await this.getToken()
                    //         await this.$refs.gofixTable.reloadTableItems()
                    //     }
                    // }
                    reject();
                });
        },
        // async downloadFile(item, isClick = false) {
        //     if(isClick) this.retry = 0
        //     this.loading = true
        //     await fetch(`https://media.mydronefleets.com/m/${item.original_file_media_id}/original`, {
        //             method: "GET",
        //             headers: {
        //                 'Authorization': `Bearer ${this.garudaToken}`
        //             }
        //         })
        //     .then( async res => {
        //         if (!res.ok) {
        //             const error = {
        //                 message: `Response status: ${res.status}`,
        //                 status: res.status,
        //             };
        //             throw error;
        //         }
        //         this.retry = 0
        //         const filename =  res.headers.get('Content-Disposition').split('filename=')[1];
        //         return {response: await res.blob(), filename: filename}})
        //     .then( ({response, filename}) => {        
        //         var url = window.URL.createObjectURL(new Blob([response]));
        //         var a = document.createElement('a');
        //         a.href = url;
        //         a.download = filename ? filename : item.name;
        //         document.body.appendChild(a);
        //         a.click();
        //         a.remove();
        //         this.loading = false
        //     }).catch(async (err) => {
        //         console.log(err)
        //         this.loading = false
        //         if(err && err.status && err.status == 401) {
        //             this.retry = this.retry + 1
        //             if(this.retry <= 3) {
        //                 await this.getToken()
        //                 await this.downloadFile(item)
        //                 return
        //             }
        //         }
        //     })
        // },
        downloadFile(item) {
            const nameFile = `${item.name}`
            this.downloadingModal.open = true;
            this.$store.dispatch(`GarudaController/downloadDocument`, {
                media_id: item.original_file_media_id,
                document_name: item.name,
                type: 'original'
            })
            .then( response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', nameFile);
                document.body.appendChild(link);
                link.click();
                this.downloadingModal.open = false;
            })
            .catch(error => {
                this.downloadingModal.open = false;
            });
        },
        getToken() {
            this.$store.dispatch( 'GarudaController/getGarudaToken')
        }
    }
}
</script>